import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type SelectPageItemProps = {
  placeholder?: string;
  value: number;
  onChange: (prop: number) => void;
  itemList?: number[];
};

const PER_PAGE_ITEMS = [10, 20, 30, 40, 50, 100, 200];
export const SelectPageItem = ({
  placeholder = "Select Per Page Record",
  value = 10,
  onChange,
  itemList = PER_PAGE_ITEMS,
}: SelectPageItemProps) => {
  return (
    <div className="mt-3 md:mt-0">
      <Select
        value={"" + value}
        defaultValue="10"
        onValueChange={(prop) => onChange(+prop)}
      >
        <SelectTrigger className="md:w-[70px] w-full">
          <SelectValue placeholder={placeholder}>{value}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {itemList.map((item) => (
            <SelectItem key={item} value={"" + item}>
              {item} items per page
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
